import { Injectable } from '@angular/core';
import { ReceiptType, ReceiptTypeCodes } from '@checkout-v2/const';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutActions } from '../store/actions/';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ReceiptTypeFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  loadReceiptTypes(): void {
    this.store.dispatch(new CheckoutActions.LoadReceiptType());
  }

  resetReceiptTypes(): void {
    this.store.dispatch(new CheckoutActions.ResetReceiptType());
  }

  getReceiptTypes(): Observable<ReceiptType[]> {
    return this.store.pipe(select(CheckoutSelectors.getReceiptTypes));
  }

  setActiveReceiptType(code: ReceiptTypeCodes): void {
    this.store.dispatch(new CheckoutActions.SetActiveReceiptType(code));
  }

  getActiveReceiptType(): Observable<ReceiptType | undefined> {
    return combineLatest([this.getReceiptTypes(), this.getActiveReceiptTypeId()]).pipe(
      map(([modes, code]: [ReceiptType[], ReceiptTypeCodes | undefined]) =>
        modes?.find((mode: ReceiptType) => mode.code === code),
      ),
    );
  }

  getActiveReceiptTypeId(): Observable<ReceiptTypeCodes | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActiveReceiptType));
  }
}
